import { Injectable } from '@angular/core';

import { HttpServiceBase } from '../core/http-service-base';
import { ProfileQuestion } from '../models/profile-questions';
import { CheckProfileRequest } from '../models/profile/check-profile-request';
import { CheckProfileResponseBase } from '../models/profile/check-profile-response-base';
import { SessionRequest } from '../models/session-request';
import { SessionResponse } from '../models/session-response';
import { BeaconRequest } from '../models/beacon-request-data';

@Injectable({
  providedIn: "root"
})
export class SessionService extends HttpServiceBase {
  constructor() {
    super();
  }

  async createSession(inputData: SessionRequest, errorCallback?: (error: Error) => void): Promise<SessionResponse> {
    const self = this;
    const output: SessionResponse = await self.post<SessionRequest, SessionResponse>("/sessions", inputData, null, errorCallback);
    return output;
  }

  async ping(): Promise<string> {
    const self = this;
    return await self.get<any, string>("/health/ping");
  }
  async getRespondentProfileQuestionByLanguageId(languageId: number, errorCallback?: (error: Error) => void): Promise<ProfileQuestion> {
    const self = this;
    const output: ProfileQuestion = await self.post<number, ProfileQuestion>("/sessions/profile-questions?languageId=" + languageId, null, null, errorCallback);
    return output;
  }
  // async getGenderAnswerCode(gender: number, languageId: number, errorCallback?: (error: Error) => void): Promise<number> {
  //   const self = this;
  //   const output: number = await self.post<number, number>("/sessions/gender-answercode?gender=" + gender + "&languageId=" + languageId, null, null, errorCallback);
  //   return output;
  // }
  async checkProfile(inputData: CheckProfileRequest, errorCallback?: (error: Error) => void): Promise<CheckProfileResponseBase> {
    const self = this;
    const response = await self.post<CheckProfileRequest, CheckProfileResponseBase>("/surveys/check-profile", inputData, null, errorCallback);
    const output: CheckProfileResponseBase = CheckProfileResponseBase.createInstance(response);
    return output;
  }
  async saveBeaconData(inputData: BeaconRequest, errorCallback?: (error: Error) => void): Promise<null> {
    const self = this;
    const output = await self.post<BeaconRequest, null>("/sessions/save-pidbeacon", inputData, null, errorCallback);
    return output;
  }
}
